import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { filter, map, Observable } from 'rxjs';
import { CompanyDataMgmtService } from '../services/company-data-mgmt.service';
import { MultiDomainMgmtService } from '../services/multi-domain-mgmt.service';
import { DomainType } from 'ngx-heka-design-lib';

@Injectable({
  providedIn: 'root'
})
export class OnboardingGuard {
  constructor(
    private companyDataMgmtService: CompanyDataMgmtService,
    private multiDomainMgmtService: MultiDomainMgmtService,
    private router: Router
  ) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.multiDomainMgmtService.getSharedMultiDomainProfile().pipe(
      filter(p => p != null),
      map(profile => {
        if (!profile.domains?.length) {
          return this.checkCompanyData();
        }

        const hasBlacklisted = !!profile.domains.find(d => d.domainType == DomainType.BLACKLISTED);

        if (hasBlacklisted) {
          this.router.navigate(['company-check']);
          return false;
        }
        return this.checkCompanyData();
      })
    );
  }

  private checkCompanyData(): boolean {
    if (this.companyDataMgmtService.checkIsSanctionedCompany()) {
      this.router.navigate(['company-check']);
      return false;
    }
    return true;
  }
}
